/**
 * Series Chart Type 선택 Modal 관련 기능 구현
 *   - Modal Open
 *   - 확인 클릭시 처리
 */
import BriqueChart from './BriqueChart'

export default {
  /**
  * Chart Type 선택 모달 대화 상자의 데이터를 세팅한다.
  * @param {Object} element Chart Element
  * @param {String} seriesName Series Name
  */
  openChartModalChartType (element, seriesName) {
    element.parentElement.__vue__.chartModalChartType.visible = true
    element.parentElement.__vue__.chartModalChartType.chartData = element.briqueChartData.tracesOriginal
    element.parentElement.__vue__.chartModalChartType.seriesName = seriesName
    element.parentElement.__vue__.chartModalChartType.beforeType = element.briqueChartData.getSeriesChartType(element, seriesName)
    element.parentElement.__vue__.chartModalChartType.beforeMode = element.briqueChartData.getSeriesChartMode(element, seriesName)
    element.parentElement.__vue__.chartModalChartType.beforeFill = element.briqueChartData.getSeriesChartFill(element, seriesName)
    element.parentElement.__vue__.chartModalChartType.beforeOrientation = element.briqueChartData.getSeriesChartOrientation(element, seriesName)
  },

  /**
    * Marker 선택 차트 모달에서 확인 버튼 클릭시 처리
    * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
    * @param {Object} chartVue Chart Vuew Object
    * @param {String} seriesName Series Name
    * @param {Object} data 선택된 데이터
    */
  onClickConfirmButtonInModalChartType (returnObject, chartVue, seriesName, data) {
    let element = chartVue.$el.children[0]
    if (data.type === 'pie') {
      const x = element.briqueChartData.getXValues(element, seriesName)
      const y = element.briqueChartData.getYValues(element, seriesName)
      element.briqueChartData.setSeriesStyle(seriesName, { type: data.type, mode: data.mode, fill: data.fill, orientation: data.orientation, labels: x, values: y })
    } else {
      element.briqueChartData.setSeriesStyle(seriesName, { type: data.type, mode: data.mode, fill: data.fill, orientation: data.orientation, labels: [], values: [], showlegend: true })
    }
    BriqueChart.setYMinMax(element, element.briqueChartData.tracesOriginal)
    BriqueChart.react(element, element.data)
  }

}
